import { useEffect, useState } from "react";
import SEO from "@/components/SEO";
import Breadcrumbs from "@/components/Breadcrumbs";
import { KineticLines } from "@/components/Motion";
import { ProjectCard } from "@/components/Cards";
import CTASection from "@/components/CTASection";
import api from "@/lib/api";

export default function Projects() {
  const [projects, setProjects] = useState([]);
  useEffect(() => { api.get("/projects").then((r) => setProjects(r.data)).catch(() => {}); }, []);

  return (
    <div data-testid="projects-page">
      <SEO title="Projects & Applications" path="/projects"
        description="Application examples of STJ Innovations cleanroom equipment: pass box integration, LAF workstations and dispensing containment engineered to facility requirements." />
      <section className="blueprint-dark bg-ink">
        <div className="mx-auto max-w-7xl px-4 py-20 sm:px-6 lg:px-8 lg:py-24">
          <Breadcrumbs dark items={[{ label: "Projects" }]} />
          <p className="eyebrow eyebrow-light">Projects & Applications</p>
          <KineticLines lines={["Applications in", "Controlled Environments"]}
            className="mt-5 font-display text-4xl font-medium leading-[1.06] tracking-tight text-white sm:text-5xl" />
          <p className="mt-6 max-w-2xl text-base leading-relaxed text-slate-400">
            Case studies from genuine STJ installations — each documenting the requirement, engineered solution, products used and outcome, with real project photography.
          </p>
        </div>
      </section>
      <section className="mx-auto max-w-7xl px-4 py-20 sm:px-6 lg:px-8 lg:py-24">
        <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3" data-testid="projects-grid">
          {projects.map((p, i) => <ProjectCard key={p.slug} project={p} index={i} />)}
        </div>
        {projects.length === 0 && (
          <div className="border border-line bg-mist p-10 sm:p-14" data-testid="projects-empty-state">
            <p className="eyebrow">In Preparation</p>
            <h2 className="mt-4 max-w-xl font-display text-2xl font-medium tracking-tight text-ink">
              Our first case studies are being documented.
            </h2>
            <p className="mt-4 max-w-2xl text-sm leading-relaxed text-steel">
              Every STJ case study will document a genuine installation: the customer's requirement, the engineered solution, the products used, technical details and the outcome — with real project photography. We publish only work we have actually delivered. In the meantime, our product pages show what we build and how we engineer it.
            </p>
          </div>
        )}
      </section>
      <CTASection />
    </div>
  );
}
